import { z } from "zod";
import { colorPaletteValidNames } from "../skins/palettes";
export const BladeCommonSchema = z.object({
    layout: z.string().optional(),
    fragmentId: z.string().optional(),
    palette: z.enum(colorPaletteValidNames).optional(),
});
//# sourceMappingURL=common.js.map